import React from "react";
import {
  TimelineContent,
  TimelineMetaList,
  TimelineMetaRow,
  TimelineNewBadge,
  TimelineTitle,
  TimelineTitleRow,
} from "../TimelineLayout";

const TargetOutcomeUpdated = ({milestone}) => (
  <TimelineContent>
    <TimelineTitleRow>
      <TimelineTitle>{milestone.milestone}</TimelineTitle>
      {milestone.notify && <TimelineNewBadge>new</TimelineNewBadge>}
    </TimelineTitleRow>
    <TimelineMetaList>
      <TimelineMetaRow>
        <span className="timeline-meta-label">change by:</span>
        <span className="timeline-meta-value">{milestone.contributor}</span>
      </TimelineMetaRow>
      <TimelineMetaRow>
        <span className="timeline-meta-label">date:</span>
        <span className="timeline-meta-value">{milestone.date}</span>
      </TimelineMetaRow>
      <TimelineMetaRow>
        <span className="timeline-meta-label">new target outcome:</span>
        <span className="timeline-meta-value">{milestone.details}</span>
      </TimelineMetaRow>
    </TimelineMetaList>
  </TimelineContent>
)

export default TargetOutcomeUpdated
